import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { BoldText, Container, Text, tealBackground, tealDark700 } from "@RooUI";

import { useRooTranslation } from "../../Common/Wrappers/useRooTranslation";

import { updateHospital } from "../../api/hospital";
import { CalendlyView, CalendlyViewProps } from "../../Common/CalendlyView/CalendlyView";
import HospitalRegistrationBookCallImg from "../../static/images/HospitalRegistrationBookCall.png";
import { RootState } from "../../store";
import { useRegistrationContext } from "../registrationContext";
import RegistrationPage from "../RegistrationPage";
import {
  BookCallContainer,
  BookCallHeaderContainer,
  RegistrationForm as RegistrationFormComponent,
} from "../styles";
import { EventTracker, Event } from "../../tracking/service/EventTracker/EventTrackerService";
export function HospitalBookCall() {
  const { t } = useRooTranslation();
  const history = useHistory();
  const loginData = useSelector((state: RootState) => state.login);
  const { registrationContext } = useRegistrationContext() ?? {};

  const {
    email: loginEmail,
    userName: loginFullName,
    fullName: loginHospitalName,
    phoneNumber: loginHospitalPhoneNumber,
    hospitalId: loginHospitalId,
  } = loginData ?? {};

  const {
    emailId: contextEmail,
    firstName: contextFirstName,
    lastName: contextLastName,
    mobilePhoneNumber: contextMobilePhoneNumber,
    calendlyLink: contextCalendlyLink,
    hospitalId: contextHospitalId,
    hospitalName: contextHospitalName,
  } = registrationContext ?? {};

  const calendlyLink = contextCalendlyLink ?? localStorage.getItem("calendlyLink") ?? "";

  const hospitalId = contextHospitalId ?? loginHospitalId;
  const hospitalName = contextHospitalName ?? loginHospitalName ?? "";

  const email = contextEmail ?? loginEmail ?? "";
  const phone = contextMobilePhoneNumber ?? loginHospitalPhoneNumber ?? "";

  let name = "";
  if (contextFirstName && contextLastName) {
    name = `${contextFirstName} ${contextLastName}`;
  } else if (loginFullName) {
    name = loginFullName;
  }

  useEffect(() => {
    EventTracker.send({
      eventName: Event.Name.HOSPITAL_SIGNUP_COMPLETE,
      eventType: Event.Type.PAGE_VIEW,
      entityType: Event.Entity.HOSPITAL,
      entityId: hospitalId,
    });
  }, [hospitalId]);

  const onContinue = async () => {
    await updateHospital({ hospitalId, isRegistrationComplete: 1, isForRegistration: 1 });
    const isPendingHospitalLoginEnabled = true;
    if (isPendingHospitalLoginEnabled) {
      history.push({
        pathname: "/hospital",
        state: {
          isReload: true,
        },
      });
      localStorage.setItem("isRegistrationComplete", "1");
    } else {
      history.push({
        pathname: "/register/success",
      });
    }
  };

  const calendlyProps: CalendlyViewProps = {
    calendlyLink,
    email,
    name,
    phone,
    utmSource: "hospital-registration",
    hospitalName,
    onEventScheduled: onContinue,
  };

  return (
    <RegistrationPage
      title={t("registration.hospitalBookCall.title")}
      subtitle={t("registration.hospitalBookCall.subtitle")}
      showProgress={false}
      showLogout={true}
      rightContainerContent={
        <BookCallContainer>
          <img src={HospitalRegistrationBookCallImg} />
          <Container backgroundColor={tealBackground}>
            <BookCallHeaderContainer>
              <BoldText color={tealDark700}>
                {t("registration.hospitalBookCall.whyBookCall.header")}
              </BoldText>
            </BookCallHeaderContainer>
            <Text>{t("registration.hospitalBookCall.whyBookCall.intro")}</Text>
            <ul>
              <li>
                <Text>{t("registration.hospitalBookCall.whyBookCall.benefits.features")}</Text>
              </li>
              <li>
                <Text>{t("registration.hospitalBookCall.whyBookCall.benefits.needs")}</Text>
              </li>
              <li>
                <Text>{t("registration.hospitalBookCall.whyBookCall.benefits.questions")}</Text>
              </li>
            </ul>
          </Container>
        </BookCallContainer>
      }
      leftContainerContent={
        <RegistrationFormComponent>
          <CalendlyView {...calendlyProps} />
        </RegistrationFormComponent>
      }
    />
  );
}
